import { Component, OnInit } from '@angular/core';
import {
  RiskService,
  RiskServiceBlockedCardsContainer,
  RiskServiceDormantCardsContainer
} from '../../services/risk.service';
import {Card} from '../../../dto/card';
import {toDateString} from '../../../providers/app-date-adapter';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';

@Component({
  selector: 'app-dormant-cards',
  templateUrl: './dormant-cards.component.html',
  styleUrls: ['./dormant-cards.component.css']
})
export class DormantCardsComponent implements OnInit {

  constructor(
    private riskService: RiskService,
  ) { }

  columns = [

    { columnDef: 'token', header: 'Token', cell: (row: Card) => `${row.token}` },
    { columnDef: 'gpsCardStatus', header: 'GPS Status', cell: (row: Card) => `${row.gpsCardStatus}` },
    { columnDef: 'customer.firstName', header: 'First Name', cell: (row: Card) => `${row.customer.firstName}` },
    { columnDef: 'customer.lastName', header: 'Last Name', cell: (row: Card) => `${row.customer.lastName}` },
    { columnDef: 'customer.email', header: 'Email', cell: (row: Card) => `${row.customer.email}` },
    { columnDef: 'product.name', header: 'Product', cell: (row: Card) => `${row.productName}` },
    { columnDef: 'status', header: 'Status', cell: (row: Card) => `${row.statusName}` },
    { columnDef: 'expireDate', header: 'Expiry Date', cell: (row: Card) => `${toDateString(row.expireDate)}` },
  ];
  dataSource = new MultiCrudDataSource(new RiskServiceDormantCardsContainer(this.riskService));
  getRowClass = (item: Card): string => {
    const classes = [];

    // TODO implement this if necessary
    return classes.join(' ');
  };
  getCustomerOverviewLink = (item: Card): string => '/customers-overview/' + item.customerId.toString();


  ngOnInit(): void {


  }

}
